import * as React from "react";
import {RootState} from "../../../store/reducer/root/RootState";
import {connect} from "react-redux";
import MultiSelectList from "../../../hiberUiKit/src/molecules/MultiSelectList/MultiSelectList";
import {WorkspaceFilterReduxProps} from "./WorkspaceFilter";
import MultiSelectWorkspaceFilter from "./MultiSelectWorkspaceFilter";
import JobWarrantyRegistrationStatus from "../../../model/job/JobWarrantyRegistrationStatus";

class JobWarrantyRegistrationStatusFilter extends MultiSelectWorkspaceFilter<JobWarrantyRegistrationStatus> {
	renderContent(items: JobWarrantyRegistrationStatus[]): JSX.Element {
		return (
			<div className={"c-filter-status-input-container"}>
				<MultiSelectList items={items}
								 itemToId={(item: JobWarrantyRegistrationStatus) => item.value}
								 itemToLabel={(item: JobWarrantyRegistrationStatus) => item.label}
								 selectedItemIds={this.getSelectedItems().map(s => s.value)}
								 onUpdate={this.onChange}
								 updateOnChange
								 componentBetweenInputAndList={this.getNegationCheckbox()}/>
			</div>
		)
	}

	itemToId(item: JobWarrantyRegistrationStatus): string {
		return item.value;
	}

	itemToLabel(item: JobWarrantyRegistrationStatus): string {
		return item.label
	}
}

function mapStateToProps(state: RootState) {
	return {
		items: state.jobStatus.jobWarrantyRegistrationStatuses
	}
}

export default connect<WorkspaceFilterReduxProps<JobWarrantyRegistrationStatus>>(mapStateToProps)(
	JobWarrantyRegistrationStatusFilter)
